import React from 'react';

import { SliderArrow, SliderWithArrowProps } from '../../helpers';
import { CustomArrows } from './CustomArrows';
import { InsideArrows } from './InsideArrows/InsideArrows';
import { OutsideArrows } from './OutsideArrows/OutsideArrows';

interface IArrowsProps {
  arrows: SliderWithArrowProps;
  handlePrevClick: () => void;
  handleNextClick: () => void;
  isEnd: boolean;
  isBeginning: boolean;
  isOne: boolean;
  hideArrows: boolean;
  loop?: boolean;
}

export const Arrows = ({
  arrows,
  handlePrevClick,
  handleNextClick,
  isEnd,
  isBeginning,
  isOne,
  hideArrows,
  loop,
}: IArrowsProps) => {
  switch (arrows.type) {
    case SliderArrow.OUTSIDE:
      return (
        <OutsideArrows
          rightComponent={arrows.componentRight}
          leftComponent={arrows.componentLeft}
          visibleForMobile={arrows.visibleForMobile}
          isBeginning={isBeginning}
          isEnd={isEnd}
          dark={arrows.dark}
          handleNextClick={handleNextClick}
          handlePrevClick={handlePrevClick}
        />
      );
    case SliderArrow.INSIDE:
      return (
        <InsideArrows
          visibleForMobile={arrows.visibleForMobile}
          isBeginning={isBeginning}
          isEnd={isEnd}
          handlePrevClick={handlePrevClick}
          handleNextClick={handleNextClick}
          hideArrows={hideArrows}
          insetLeftArrow={arrows.insetLeftArrow}
          insetRightArrow={arrows.insetRightArrow}
          loop={loop}
          isOne={isOne}
        />
      );
    case SliderArrow.CUSTOM:
      return (
        <CustomArrows
          componentLeft={arrows.componentLeft}
          componentRight={arrows.componentRight}
          handlePrevClick={handlePrevClick}
          handleNextClick={handleNextClick}
        />
      );
    default:
      return null;
  }
};
